import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FieldMapping } from 'src/app/dashboard/model/field-mapping';
import { NodeStats } from 'src/app/data-types/model/node-stats';
import { TypeMapping } from 'src/app/data-types/model/type-mapping';
import { TypeMappingOverview } from 'src/app/data-types/model/type-mapping-overview';
import { BowmanCacheService } from 'bowman-cache';
import { ActionResult, HelperFunctions } from 'bowman-commons';
import { BowmanLoggerService } from 'bowman-logger';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
     providedIn: 'root'
})
export class TypeMappingService {

     private _mainUrl: string = window.location.pathname + '/api/type/';
     headers: HttpHeaders = new HttpHeaders();

     constructor(private _http: HttpClient, private _bowmanCacheService: BowmanCacheService, private _loggerService: BowmanLoggerService) {
          this.headers = new HttpHeaders().append('Content-Type', 'application/json').append('Accept', 'application/json');
     }


     public dynamicFieldMappingList(): Observable<ActionResult<{ [name: string]: Array<FieldMapping> }>> {
          const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + 'dynamicFieldMappingList');
          return this._http.get<ActionResult<{ [name: string]: Array<FieldMapping> }>>(dataUrl, { headers: this.headers }).pipe(catchError(this.handleError));

     }

     public listTypeMappings(): Observable<ActionResult<Array<TypeMapping>>> {
          const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + 'list');
          return this._http.get<ActionResult<Array<TypeMapping>>>(dataUrl, { headers: this.headers }).pipe(catchError(this.handleError));

     }

     public createTypeMapping(request: TypeMapping): Observable<ActionResult<Array<string>>> {
          const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + 'create');
          this._bowmanCacheService.flushServiceCacheByMethod('listTypeMappings');
          this._bowmanCacheService.flushServiceCacheByMethod('dynamicFieldMappingList');
          this._bowmanCacheService.flushServiceCacheByMethod('getTypeMappingOverview');
          return this._http.post<ActionResult<Array<string>>>(dataUrl, request, { headers: this.headers }).pipe(catchError(this.handleError));

     }
     public updateTypeMapping(request: TypeMapping): Observable<ActionResult<Array<string>>> {
          const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + 'update');
          this._bowmanCacheService.flushServiceCacheByMethod('listTypeMappings');
          this._bowmanCacheService.flushServiceCacheByMethod('dynamicFieldMappingList');
          this._bowmanCacheService.flushServiceCacheByMethod('getTypeMappingOverview');
          return this._http.put<ActionResult<Array<string>>>(dataUrl, request, { headers: this.headers }).pipe(catchError(this.handleError));
     }

     public deleteTypeMapping(name: string): Observable<ActionResult<boolean>> {
          const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + 'delete/' + name);
          this._bowmanCacheService.flushServiceCacheByMethod('listTypeMappings');
          this._bowmanCacheService.flushServiceCacheByMethod('dynamicFieldMappingList');
          this._bowmanCacheService.flushServiceCacheByMethod('getTypeMappingOverview');
          return this._http.delete<ActionResult<boolean>>(dataUrl, { headers: this.headers }).pipe(catchError(this.handleError));
     }
     public closeAllIndexes(name: string): Observable<ActionResult<number>> {
          const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + 'closeAllIndexes/' + name);
          this._bowmanCacheService.flushServiceCacheByMethod('listTypeMappings');
          this._bowmanCacheService.flushServiceCacheByMethod('dynamicFieldMappingList');
          this._bowmanCacheService.flushServiceCacheByMethod('getTypeMappingOverview');
          return this._http.get<ActionResult<number>>(dataUrl, { headers: this.headers }).pipe(catchError(this.handleError));
     }
     public openAllIndexes(name: string): Observable<ActionResult<number>> {
          const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + 'openAllIndexes/' + name);
          this._bowmanCacheService.flushServiceCacheByMethod('listTypeMappings');
          this._bowmanCacheService.flushServiceCacheByMethod('dynamicFieldMappingList');
          this._bowmanCacheService.flushServiceCacheByMethod('getTypeMappingOverview');
          return this._http.get<ActionResult<number>>(dataUrl, { headers: this.headers }).pipe(catchError(this.handleError));
     }
     public openIndex(name: string): Observable<ActionResult<number>> {
          const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + 'openIndex/' + name);
          this._bowmanCacheService.flushServiceCacheByMethod('listTypeMappings');
          this._bowmanCacheService.flushServiceCacheByMethod('dynamicFieldMappingList');
          this._bowmanCacheService.flushServiceCacheByMethod('getTypeMappingOverview');

          return this._http.get<ActionResult<number>>(dataUrl, { headers: this.headers }).pipe(catchError(this.handleError));
     }
     public getTypeMappingOverview(): Observable<ActionResult<Array<TypeMappingOverview>>> {
          const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + 'getOverview')
          return this._http.get<ActionResult<Array<TypeMappingOverview>>>(dataUrl, { headers: this.headers }).pipe(map(result => {
               if (result.status == 'OK') {
                    result.result.forEach(type => {
                         (type.eventsCount as any) == 'NaN' ? type.eventsCount = 0 : null;
                         (type.eventsPerDay as any) == 'NaN' ? type.eventsPerDay = 0 : null;
                         (type.eventsPerHour as any) == 'NaN' ? type.eventsPerHour = 0 : null;
                         (type.eventsPerMin as any) == 'NaN' ? type.eventsPerMin = 0 : null;
                         (type.eventsPerSec as any) == 'NaN' ? type.eventsPerSec = 0 : null;
                         (type.eventsTotal as any) == 'NaN' ? type.eventsTotal = 0 : null;
                    });
               }
              return result;
          }), catchError(this.handleError));
     }

     public getAvailableSpaceByNodes(): Observable<ActionResult<Array<NodeStats>>> {
          const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + 'getAvailableSpace');
          return this._http.get<ActionResult<Array<NodeStats>>>(dataUrl, { headers: this.headers }).pipe(map(result => {
               if (result.status == 'OK') {
                    return result;
               }
          }), catchError(this.handleError));

     }





     private handleError(error: any) {
          let parsedError: any;
          if (error && error.error && error.error.message) {
               parsedError = error.error.message;
          } else if (error && error.message) {
               parsedError = error.message;
          } else if (error && error._body) {
               parsedError = error._body;
          } else {
               parsedError = 'Type Mapping Service Error';
          }
          return observableThrowError(parsedError);
     }
}
